import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import { Edit, Delete, Print } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
  validatedate_min_max,
  getlocalstoragedate,
  setlocalstoragedate,
  getRowData,
  setKeyboardShortcuts,
  csvFileName,
  getRowOfRT,
} from "../SystemUtility/SystemUtility";
//import { fetchLedgerDetail } from './API'
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import PaymentEntry from "./PaymentEntry";
import PaymentMode from "./PaymentMode";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import { apiURL, fetchPayment } from "./API";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import ResetDate from "../images/resetdate.png";
import CtART from "./CustomTool/ResponsiveTable";
import PaymentPrint from "./PaymentPrint";
import { withRouter } from "../HOC/withRouter";

class PaymentList extends Component {
  state = {
    CompanyName: [],
    LedgerType: [],
    LedgerSupplier: [],
    PaymentMode: [],
    Company: [],
    LedgerGroup: [],
    Ledger: [],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "bint_expensesrno", label: "Voucher No" },
      { id: "dat_dateDMY", label: "Date" },
      { id: "vac_groupname", label: "Legder Group" },
      { id: "vac_ledgername", label: "Legder" },
      { id: "dec_amount", label: "Amount" },
      { id: "vac_remark", label: "Remark" },
      { id: "bint_acid", label: "bint_acid", hide: true },
    ],
    columnsdata: [
      {
        accessorKey: "bint_expensesrno",
        header: "Voucher No",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 70,
      },
      { accessorKey: "dat_dateDMY", header: "Date", size: 90 },
      { accessorKey: "dat_date", header: "dat_date" },
      { accessorKey: "vac_groupname", header: "Legder Group" },
      { accessorKey: "vac_ledgername", header: "Legder" },
      {
        accessorKey: "dec_amount",
        header: "Amount",
        align: "right",
        Cell: ({ cell }) => parseFloat(cell.getValue()).toLocaleString("en-IN"),
        isNumeric: true,
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 90,
      },
      {
        accessorKey: "vac_remark",
        header: "Remark",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
        Cell: ({ cell }) => (
          <div dangerouslySetInnerHTML={{ __html: cell.getValue() }} />
        ),
      },
      { accessorKey: "bint_acid", header: "bint_acid", hide: true },
    ],

    paymentModeRows: [],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "PaymentList:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "PaymentList:",
        actionType: "AlertResponsive",
        hide:
          this.props.userPrivilege.Payment == "R" ||
          this.props.userPrivilege.Payment == "W",
      },
      {
        name: "Print expense",
        icon: <Print />,
        link: "PaymentList:",
        actionType: "AlertResponsive",
        hide: this.props.userPrivilege.Payment == "R",
      },
    ],
    keyColumn: [
      "bint_expensesrno", //0
      "dat_date", //1
      "vac_groupname", //2
      "vac_ledgername", //3
      "dec_amount", //4
      "vac_remark", //5
      "bint_acid", //6
    ],
    paymentModeKeyColumn: [],
    searchData: {
      bint_expensesrno: "",
      dat_date: "",
      vac_groupname: "",
      vac_ledgername: "",
      dec_amount: "",
      vac_remark: "",
    },
    searchColumns: [],
    searchRows: [],
    paymentModeSearchRows: [],
    searchOpen: false,
    paymentModeSearchOpen: false,
    searchRowsCount: 0,
    paymentModeSearchRowsCount: 0,

    formData: {
      txtVoucherNo: "",
      dtpDate: "",
      cmbLedgerGroup: "",
      cmbLedger: "",
      txtAmount: "",
      txtRemark: "",
      dtpFromDate: "",
      dtpToDate: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
    paymentModeRowsCount: 0,
    paymentModerowsPerPage: 50,
    GeneralSettingList: [],
    removeKeyboardShortCuts: null,
  };

  //region Component
  componentDidMount() {
    document.title = "RA : Payment List";
    this.props.setActiveMenu("PaymentList");
    this.setSearchColumns();
    this.ShortCut();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //endtregion Component

  //#region handle
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
  }
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };

  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts({
        handleOnclickAdd: this.handleOnNewEntryClick,
      }),
    });
  };
  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchInputChangeTrim = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value.trim(),
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.bint_expensesrno.length === 0 ||
            (row["bint_expensesrno"] &&
              row["bint_expensesrno"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.bint_expensesrno.toLowerCase()
                ))) &&
          (this.state.searchData.dat_date.length === 0 ||
            (row["dat_date"] &&
              row["dat_date"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dat_date.toLowerCase()))) &&
          (this.state.searchData.vac_groupname === 0 ||
            (row["vac_groupname"] &&
              row["vac_groupname"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_groupname.toLowerCase()
                ))) &&
          (this.state.searchData.vac_ledgername === 0 ||
            (row["vac_ledgername"] &&
              row["vac_ledgername"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_ledgername.toLowerCase()
                ))) &&
          (this.state.searchData.dec_amount.length === 0 ||
            (row["dec_amount"] &&
              row["dec_amount"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_amount.toLowerCase()))) &&
          (this.state.searchData.vac_remark.length === 0 ||
            (row["vac_remark"] &&
              row["vac_remark"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_remark.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "dtpFromDate" || e.target.name === "dtpToDate") {
          this.setfrom_todate();
        }
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      this.removeKeyboardShortCuts();
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          // alertTitle={'Sales Item Entry'}
          alertMessage={
            <PaymentEntry
              refreshPaymentList={this.refreshPaymentList}
              dtpFromDate={this.state.formData.dtpFromDate}
              dtpToDate={this.state.formData.dtpToDate}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
          // handleOnClickNo={this.ShortCut}
          handleOnClickNo={() => {
            localStorage.setItem("openARD", false);
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  handleChangePaymentModeRowsPerPage = (paymentModeRowsPerPage) => {
    this.setState({ paymentModeRowsPerPage });
  };

  handleARDonActionClick = (row) => {
    let bint_acid = row.bint_acid,
      // bint_salessrno = values[18].value,
      bint_acyear = localStorage.getItem("ACY"),
      actionName = row.actionName,
      bint_expensesrno = row.bint_expensesrno,
      EditPaymentData = [];
    if (actionName === "Edit") {
      let ARD = null;
      EditPaymentData = [
        {
          bint_expensesrno: row.bint_expensesrno,
          dat_date: row.dat_date,
          vac_groupname: row.vac_groupname,
          vac_ledgername: row.vac_ledgername,
          dec_amount: row.dec_amount,
          vac_remark: row.vac_remark,
        },
      ];
      this.setState({ ARD }, () => {
        ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            // fullscreenOnly={true}
            maxWidthClass={"xl"}
            // Edit : Sales Item Entry
            alertMessage={
              <PaymentEntry
                refreshPaymentList={this.refreshPaymentList}
                bint_expensesrno={bint_expensesrno}
                EditPaymentData={EditPaymentData}
                dtpFromDate={this.state.formData.dtpFromDate}
                dtpToDate={this.state.formData.dtpToDate}
              />
            }
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Voucher No. : " + bint_expensesrno + " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.deletePaymentList(
                bint_acyear,
                bint_acid,
                bint_expensesrno
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else if (actionName === "Print expense") {
      this.openPaymentPrint(bint_acyear, bint_acid, bint_expensesrno);
    }
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_acid", "bint_expensesrno"]);
    let bint_acid = row.bint_acid,
      bint_acyear = localStorage.getItem("ACY"),
      bint_expensesrno = row.bint_expensesrno;
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelAgree="Delete"
          labelDisagree="Cancel"
          alertTitle={
            "Do you want to Delete Voucher No. : " + bint_expensesrno + " ?"
          }
          alertMessage=""
          handleOnClickYes={() => {
            return this.deletePaymentList(
              bint_acyear,
              bint_acid,
              bint_expensesrno
            );
          }}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_acid",
      "bint_expensesrno",
      "dat_date",
      "vac_groupname",
      "vac_ledgername",
      "dec_amount",
      "vac_remark",
    ]);

    let bint_acid = row.bint_acid,
      bint_acyear = localStorage.getItem("ACY"),
      bint_expensesrno = row.bint_expensesrno,
      EditPaymentData = [],
      ARD = null;
    EditPaymentData = [
      {
        bint_expensesrno: row.bint_expensesrno,
        dat_date: row.dat_date,
        vac_groupname: row.vac_groupname,
        vac_ledgername: row.vac_ledgername,
        dec_amount: row.dec_amount,
        vac_remark: row.vac_remark,
      },
    ];
    // console.log("EditReceiptData", EditReceiptData);
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // fullscreenOnly={true}
          maxWidthClass={"xl"}
          // Edit : Sales Item Entry
          alertMessage={
            <PaymentEntry
              refreshPaymentList={this.refreshPaymentList}
              bint_expensesrno={bint_expensesrno}
              EditPaymentData={EditPaymentData}
              dtpFromDate={this.state.formData.dtpFromDate}
              dtpToDate={this.state.formData.dtpToDate}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleARDonActionClick_Print = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_acid", "bint_expensesrno"]);
    let bint_acid = row.bint_acid,
      bint_acyear = localStorage.getItem("ACY"),
      bint_expensesrno = row.bint_expensesrno;
    this.openPaymentARDSelection(bint_acyear, bint_acid, bint_expensesrno);
  };

  // openPaymentPrint = (bint_acyear, bint_acid, bint_expensesrno) => {
  //   this.props.notifyProcessing();
  //   let reqData = [
  //     { name: "Op", value: "VoucherPrint" },
  //     { name: "bint_acyear", value: bint_acyear },
  //     { name: "bint_acid", value: bint_acid },
  //     { name: "bint_expensesrno", value: bint_expensesrno },
  //   ];
  //   console.log("reqData", reqData);
  //   var form = document.createElement("form");
  //   form.setAttribute("method", "post");
  //   form.setAttribute("action", apiURL + "expenseentrydetail.php");
  //   form.setAttribute("target", "view");
  //   reqData.forEach((data) => {
  //     var hiddenField = document.createElement("input");
  //     hiddenField.setAttribute("type", "hidden");
  //     hiddenField.setAttribute("name", data.name);
  //     hiddenField.setAttribute("value", data.value);
  //     form.appendChild(hiddenField);
  //     document.body.appendChild(form);
  //   });

  //   window.open("", "view");

  //   form.submit();
  //   this.props.updateProcessing("success", "PDF Open in next Tab.");
  // };

  // With Out Signature and stamp
  // openPaymentPrint = (bint_acyear, bint_acid, bint_expensesrno) => {
  //   this.props.notifyProcessing();
  //   let PrintFormat = getRowData(
  //     this.state.GeneralSettingList,
  //     "vac_key",
  //     "Print Format"
  //   );
  //   let Op = "";
  //   // console.log("PrintFormat", PrintFormat);
  //   if (PrintFormat["vac_value"] === "Gujarati Data") {
  //     Op = "VoucherPrint_HTML";
  //   } else {
  //     Op = "VoucherPrint";
  //   }

  //   let reqData = [
  //     { name: "Op", value: Op },
  //     { name: "bint_acyear", value: bint_acyear },
  //     { name: "bint_acid", value: bint_acid },
  //     { name: "bint_expensesrno", value: bint_expensesrno },
  //   ];

  //   // Create a query string from the request data
  //   let queryString = reqData
  //     .map(
  //       (data) =>
  //         encodeURIComponent(data.name) + "=" + encodeURIComponent(data.value)
  //     )
  //     .join("&");

  //   // Set the URL of the popup window
  //   let popupURL = apiURL + "expenseentrydetail.php?" + queryString;

  //   // Open the popup window
  //   window.open(
  //     popupURL,
  //     "PaymentList",
  //     "width=" +
  //       window.screen.availWidth +
  //       ",height=" +
  //       window.screen.availHeight
  //   );

  //   this.props.updateProcessing("success", "PDF Open in popup.");
  // };

  openPaymentARDSelection = (bint_acyear, bint_acid, bint_expensesrno) => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={
            <PaymentPrint
              bint_acid={bint_acid}
              bint_acyear={bint_acyear}
              bint_expensesrno={bint_expensesrno}
              GeneralSettingList={this.state.GeneralSettingList}
            />
          }
          handleOnClickNo={() => {
            document.title = "RA : Payment List";
            this.props.setActiveMenu("PaymentList");
          }}
          defaultOpenDialog={true}
        />
      );
      this.setState({ ARD });
    });
  };

  //endregion handle

  //region function

  setfrom_todate = (reset = false) => {
    setlocalstoragedate(
      "Payment",
      this.state.formData.dtpFromDate,
      this.state.formData.dtpToDate,
      reset
    );
    if (reset) {
      window.location.reload();
      this.onFormLoad();
    }
  };

  refreshPaymentList = (rows, rowsCount) => {
    this.setState({
      rows,
      rowsCount,
    });
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "bint_expensesrno",
        label: "Voucher No",
        value: this.state.searchData.bint_expensesrno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "dat_date",
        label: "Date",
        value: this.state.searchData.dat_date,
        handleOnChange: this.handleOnSearchInputChange,
        width: "130s",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "LedgerGroup",
        items: this.state.LedgerGroup,
        label: "Ledger Group",
        value: this.state.searchData.vac_groupname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "160",
        maxLength: "100",
        // colID: 'vac_groupname',
      },
      {
        cType: "CtTxt",
        id: "vac_ledgername",
        items: this.state.Ledger,
        label: "Ledger",
        value: this.state.searchData.vac_ledgername,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
        // colID:'vac_ledgername',
      },
      {
        cType: "CtTxt",
        id: "dec_amount",
        label: "Amount",
        value: this.state.searchData.dec_amount,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_remark",
        label: "Remark",
        value: this.state.searchData.vac_remark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      { cType: "Lbl", id: "bint_acid" }
    );
    this.setState({ searchColumns });
  };

  onPaymentModeClick = () => {
    // if (this.validateSales() === true) {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // alertTitle={'Sales Item Entry'}
          alertMessage={<PaymentMode />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
    // }
  };

  onFormLoad = () => {
    // let dtpFromDate = get_30DaysBack_FromCurrentDate(),
    //   dtpToDate = get_YMD_from_SYS(new Date());
    const { fromdate, todate } = getlocalstoragedate("Payment");
    let dtpFromDate = fromdate,
      dtpToDate = todate;
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpFromDate,
          dtpToDate,
        },
      },
      () => {
        this.getInfo();
      }
    );
  };

  deletePaymentList = (bint_acyear, bint_acid, bint_expensesrno) => {
    let dataLoadStatus = false;
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DeleteExpense",
        bint_acyear: bint_acyear,
        bint_acid: bint_acid,
        edit_expensesrno: bint_expensesrno,
        dat_fromdate: this.state.formData.dtpFromDate,
        dat_todate: this.state.formData.dtpToDate,
      };
      fetchPayment(reqData)
        .then((res) => {
          dataLoadStatus = true;
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.setState(
              {
                dataLoadStatus,
              },
              () => {
                this.getInfo();
              }
            );
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in deletePaymentList.", error);
        });
    });
    return true;
  };

  validatePayment = () => {
    let result = false;
    const fromDate = this.state.formData.dtpFromDate;
    const toDate = this.state.formData.dtpToDate;
    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props
      ) == false
    ) {
      return result;
    } else if (new Date(fromDate) > new Date(toDate)) {
      this.props.toastErrorMsg(
        "To Date must be greater than From Date",
        "dtpFromDate"
      );
    } else {
      result = true;
    }
    return result;
  };

  getInfo = () => {
    if (this.validatePayment()) {
      let dataLoadStatus = false;
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "ExpenseList",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          dat_fromdate: this.state.formData.dtpFromDate,
          dat_todate: this.state.formData.dtpToDate,
        };
        fetchPayment(reqData)
          .then((res) => {
            dataLoadStatus = true;
            let rows = res.data.ExpenseList,
              rowsCount = rows.length,
              GeneralSettingList = res.data.GeneralSettingList;
            // console.log(
            //   "this.props.location.state.ARD",
            //   this.props.location.state.ARD
            // );
            this.setState(
              {
                dataLoadStatus,
                rows,
                rowsCount,
                GeneralSettingList,
              },
              () => {
                if (
                  this.props.location &&
                  this.props.location.state &&
                  this.props.location.state.ARD &&
                  localStorage.getItem("openARD") == "true"
                ) {
                  this.handleOnNewEntryClick();
                }
              }
            );
          })
          .catch((error) => {
            console.log("Unknown error occurred in getInfo.", error);
          });
      });
      document.getElementById("dtpFromDate").focus();
    }
  };

  //endregion function
  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;

    let paymentModeRows = this.state.paymentModeSearchOpen
      ? this.state.paymentModeSearchRows
      : this.state.paymentModeRows;
    let paymentModeRowsCount = this.state.paymentModeSearchOpen
      ? this.state.paymentModeSearchRowsCount
      : this.state.paymentModeRowsCount;

    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Payment List</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item style={{ display: "inline-flex" }}>
                <CardContent style={{ paddingBottom: "0px" }}>
                  <CardMedia
                    component="img"
                    alt="Reset Date to Default"
                    sx={{ width: 35 }}
                    image={ResetDate}
                    onClick={() => {
                      this.setfrom_todate(true);
                    }}
                  />
                </CardContent>
                <CtDtp
                  id="dtpFromDate"
                  label="From Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpFromDate}
                  value={this.state.formData.dtpFromDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpToDate"
                  label="To Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpToDate}
                  value={this.state.formData.dtpToDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  defaultAction={this.getInfo}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtBtn label="Load" onClick={this.getInfo} variant="outlined" />
              </Grid>
            </Grid>
            {/* <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item state display={"none"}>
                <CtBtn label="Payment Mode" onClick={this.onPaymentModeClick} />
              </Grid>
            </Grid> */}
          </Grid>
        </Grid>
        <br />

        {/* <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          toolTipNewEntry="Payment Entry"
        /> */}
        <CtART
          rowsdata={this.state.rows}
          columnsdata={this.state.columnsdata}
          rowsPerPage={this.state.rowsPerPage}
          tblmaxHeight={500}
          csvFileName={csvFileName("PaymentList")}
          rowIconAction={[
            {
              label: "Edit",
              onClick: this.handleARDonActionClick_Edit,
              icon: "Edit",
              className: "secondary-button",
            },
            {
              label: "Delete",
              onClick: this.handleARDonActionClick_Delete,
              icon: "delete",
              className: "delete-button",
            },
            {
              label: "Print",
              onClick: this.handleARDonActionClick_Print,
              icon: "print",
              className: "print-button",
            },
            // this.props.userPrivilege["Entry:Proposal"] == "M"
            //   ? {
            //       label: "Delete",
            //       onClick: this.handleARDonActionClick_Delete,
            //       icon: "delete",
            //       className: "delete-button",
            //     }
            //   : "",
          ]}
          tableButtonAction={[
            {
              label: "Payment Entry",
              onClick: this.handleOnNewEntryClick,
              addPluseIcon: true,
            },
            // this.props.userPrivilege["Entry:Proposal"] != "R"
            //   ? {
            //       label: "Add New Proposal",
            //       onClick: this.handleOnNewEntryClick,
            //       addPluseIcon: true,
            //     }
            //   : "",
          ]}
          showColumnFilters={false}
          actionColSize={100}
          hideColIdList={["bint_acid", "dat_date"]}
          density={"compact"}
        />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(PaymentList))));
